import { lazy, Suspense, useState } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';
import classnames from 'classnames';
import dibsCss from 'dibs-css';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { PdpSharedRingSizeGuideModalLazy } from '../shared/PdpSharedDetail/PdpSharedRingSizeGuideModalLazy.tsx';
import { ringSize } from '../messages/pdpSwatchSelectorMessages.tsx';

import styles from '../styles/PdpSharedSwatchSelector.scss';

const SwatchSelector = lazy(
    () => import(/* webpackChunkname: "swatchSelectorMain "*/ './SwatchSelectorMain.jsx')
);

const messages = defineMessages({
    sizeGuide: {
        id: 'pdp.respSwatchSelectorRingSizeGuide',
        defaultMessage: 'Size Guide',
    },
});

const PdpRespSwatchSelectorComponent = props => {
    const {
        currency,
        onClick,
        isClient,
        item,
        user,
        relay,
        selectedSkuId,
        showSwatchDescriptionOnHover,
    } = props;
    const { isRingItem } = item || {};

    const [modalOpen, setModalOpen] = useState(false);
    const intl = useIntl();

    const swatchSelector = (
        <SwatchSelector
            currency={currency}
            selectedSkuId={selectedSkuId}
            item={item}
            userIsTrade={!!user?.isVerifiedTrade}
            transactions={null}
            onClick={onClick}
            relay={relay}
            pageLayout="PDP"
            showSwatchDescriptionOnHover={showSwatchDescriptionOnHover}
            inputSize={isRingItem ? 'small' : undefined}
        />
    );

    return (
        <Suspense fallback={''}>
            {isRingItem ? (
                <div className={classnames(dibsCss.flex, dibsCss.justifyBetween, dibsCss.mtSmall)}>
                    <div className={classnames(dibsCss.flex, dibsCss.itemsCenter)}>
                        <div
                            className={classnames(
                                dibsCss.sassyFontBodyMediumHeavy,
                                dibsCss.mrSmall
                            )}
                        >
                            {ringSize}
                        </div>
                        <div
                            className={classnames(
                                dibsCss.sassyFontBodySizeMedium,
                                styles.selectionWidth
                            )}
                        >
                            {swatchSelector}
                        </div>
                    </div>
                    <Link
                        className={dibsCss.sassyFontBodySizeSmall}
                        onClick={() => setModalOpen(true)}
                    >
                        {intl.formatMessage(messages.sizeGuide)}
                    </Link>
                    {isClient && (
                        <PdpSharedRingSizeGuideModalLazy
                            isOpen={modalOpen}
                            onClose={() => setModalOpen(false)}
                            relay={relay}
                        />
                    )}
                </div>
            ) : (
                swatchSelector
            )}
        </Suspense>
    );
};

PdpRespSwatchSelectorComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    isClient: PropTypes.bool,
    currency: PropTypes.string,
    onSwatchClick: PropTypes.func,
    selectedSkuId: PropTypes.string,
    onClick: PropTypes.func,
    showSwatchDescriptionOnHover: PropTypes.bool,

    // relay response data
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
};
export const PdpRespSwatchSelector = createFragmentContainer(PdpRespSwatchSelectorComponent, {
    item: graphql`
        fragment PdpRespSwatchSelector_item on Item {
            ...SwatchSelector_item @arguments(shouldFetchBuyerInfo: true)
            isRingItem
        }
    `,
    user: graphql`
        fragment PdpRespSwatchSelector_user on User {
            isVerifiedTrade
        }
    `,
});
